<div class="qa-variable-search" *ngIf="getScoringVariableNames(true).length">
  <i class="fa fa-search" aria-hidden="true"></i>
  <input type="search" class="form-control" [placeholder]="_(KEYS.EDITOR.SEARCH_VARIABLE)" [attr.aria-label]="_(KEYS.EDITOR.SEARCH_VARIABLE)"
         autocomplete="off" spellcheck="false" [(ngModel)]="search" [ngModelOptions]="{standalone: true}">
</div>

<form [formGroup]="form">
  <div
    class="qa-variable-row"
    *ngFor="let scoringVarName of getScoringVariableNames(true)"
    [hidden]="!matchesSearch(scoringVarName)"
    [ngClass]="{'dirty-entry': form.get(scoringVarName).dirty}"
  >
    <input
      class="form-control qa-variable-name"
      spellcheck="false"
      autocomplete="off"
      [value]="scoringVarName"
      id="{{scoringVarName}}"
      name="{{scoringVarName}}"
      [formControlName]='scoringVarName'
      [class.is-invalid]="!!nameError(scoringVarName)"
      (keydown)="onKeyDown($event, scoringInputEl, scoringVarName)"
      #scoringInputEl
    >
    <button
      type="button"
      class="qa-icon-btn qa-icon-btn-save"
      [attr.aria-label]="_(KEYS.EDITOR.SAVE_VARIABLE)"
      [disabled]="(scoringVarName === scoringInputEl.value || form.get(scoringVarName).errors) ? true : null"
      (click)="onEdit(scoringInputEl.value, scoringVarName)"
    >
      <i class="fa fa-check" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="qa-icon-btn"
      [attr.aria-label]="_(KEYS.EDITOR.RESET_VARIABLE)" [attr.title]="_(KEYS.EDITOR.RESET_VARIABLE)"
      (click)="onUndo(scoringVarName)"
    >
      <i class="fa fa-undo" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="qa-icon-btn qa-icon-btn-danger"
      [attr.aria-label]="_(KEYS.EDITOR.DELETE_VARIABLE)" [attr.title]="_(KEYS.EDITOR.DELETE_VARIABLE)"
      (click)="onRemove(scoringVarName)"
    >
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <p class="qa-variable-msg qa-variable-msg-error" *ngIf="nameError(scoringVarName) as error" role="alert">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{error}}
    </p>
  </div>
  <p *ngIf="search && !hasSearchResults()" class="qa-variable-search-empty">{{_(KEYS.EDITOR.NO_MATCHING_VARIABLES)}}</p>
</form>

<button type="button" #addVariableButton class="qa-add-variable" (click)="onAdd()">
  <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.EDITOR.ADD_SCORING_VARIABLE)}}
</button>
